import React, { useContext } from "react";
import { MDXProvider } from "@mdx-js/react";
import { Highlight, themes } from "prism-react-renderer";
import { ThemeProvider, ThemeContext } from "./src/components/ThemeContext";

const ThemedCodeBlock = (props) => {
    const { theme } = useContext(ThemeContext);
    const className = props.children.props.className || "";
    const matches = className.match(/language-(?<lang>.*)/);
    const language = matches && matches.groups && matches.groups.lang ? matches.groups.lang : "";

    const prismTheme = theme === "dark" ? themes.nightOwl : themes.github;

    return (
        <Highlight
            code={props.children.props.children.trim()}
            language={language}
            theme={prismTheme}
        >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre className={className} style={style}>
                    {tokens.map((line, i) => (
                        <div {...getLineProps({ line, key: i })}>
                            {line.map((token, key) => (
                                <span {...getTokenProps({ token, key })} />
                            ))}
                        </div>
                    ))}
                </pre>
            )}
        </Highlight>
    );
};

const components = {
    pre: (props) => <ThemedCodeBlock {...props} />,
};

export const wrapRootElement = ({ element }) => (
    <ThemeProvider>
        <MDXProvider components={components}>{element}</MDXProvider>
    </ThemeProvider>
);
